/**
 init-style
 Created by RuSsCiTy on 07.05.2018

 Init here all general styles you may need
 **/

export default function initStyle() {
 // require("../style/bootstrap-escaped.scss");
  require("../style/main.scss");

  return true;
}



// WEBPACK FOOTER //
// ./src-cookie-manager/init/style.js